var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"pl-0 py-2 py-md-4",attrs:{"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }